import {Button} from 'alm-react-components';
import accordionArrowImg from "../../../assets/images/svgicons/accordion-arrow.svg";
import {useNavigate} from 'react-router-dom';

import {useContext, useEffect, useLayoutEffect, useState} from 'react';
import CarouselSection from '../../common/CarouselSection';
import {useTranslation} from 'react-i18next';
import useGetEnrolled from '../../../hooks/useGetEnrolled';
import {ActionType, APPROUTES, constants} from '../../../assets/constants/constants';
import {useParams} from 'react-router-dom';
import useSearchhook from '../../../hooks/useSearchhook';
import Search from '../../common/Search';
import useLibrarySeeAll from '../../../hooks/useLibrarySeeAll';
import {librarySearch} from '../../../lib/utils';
import OtherSection from './OtherSection';
import getLocalizedContent from '../../../lib/getLocalizedMetaData';
import PageLoader from '../../common/loader/PageLoader';
import { AppContext } from '../../../context/AppProvider';

function Videos() {
  const navigate = useNavigate();
  const {getAllLibraryData, addBookMark, deleteBookMark, bookMarkresponse, data} =
    useLibrarySeeAll();
  const {keyword, onhandleSearch, onSearchClick} = useSearchhook();
  const {t} = useTranslation();
  const {tagsData} = useGetEnrolled();
  const {id} = useParams();
  const [loading, setLoading] = useState(true);
  const {dispatch } = useContext(AppContext);


  useEffect(() => {
    setLoading(true); // Set loading to true when data is being fetched
    getAllLibraryData(id).finally(() => {
      setLoading(false); // Set loading to false when the data fetch is complete
    });
  }, [bookMarkresponse, id]);

  const searchResult = keyword ? librarySearch(keyword, data) : data;

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <div className="px-6 lg:px-8 xl:pr-32 xl:pl-32 pt-6 md:py-14 w-[100%] md:px-8 mb-12 flex-grow">
        <div className="flex justify-between items-center">
          <Button
            onClick={() => {dispatch({ type: ActionType.SET_KEYWORD, payload:"" }); navigate(APPROUTES.library)}}
            variant="default"
            className="dark:bg-fillMidGrayCard w-6 h-6 pl-0 top-0 mr-3 mt-[2px]"
          >
            <img src={accordionArrowImg} alt={" "} className="logo cursor-pointer h-[14px] ml-4 rotate-180" />
          </Button>
          <Search onSearchClick={onSearchClick} onhandleSearch={onhandleSearch} />
        </div>

        {loading ? (
          <PageLoader />
        ) : !searchResult.length ? (
          <div className="flex justify-center items-center h-[calc(100vh-32rem)] w-full text-2xl">
            <p><span dangerouslySetInnerHTML={{ __html: (t('Videos.noDetailsFound')) }} /></p>
          </div>
        ) : (
          <>
            {searchResult.filter((item: any) =>
              item?.attributes?.tags?.includes(constants.NEW_VIDEO)
            ).length ? (
            <>
              <h2 className="text-3xl font-barlowLight mt-6"><span dangerouslySetInnerHTML={{ __html: (t('Videos.newVideos')) }} /></h2>
              <CarouselSection
                type={constants.VIDEOS}
                data={searchResult.filter((item: any) =>
                  item?.attributes?.tags?.includes(constants.NEW_VIDEO)
                )}
                addBookMark={addBookMark}
                deleteBookMark={deleteBookMark}
                seeAll={true}
                filterTag={constants.NEW_VIDEO}
                from={APPROUTES.library}
                catId={id}
              />
            </>
            ) : null}

            {tagsData?.map((res: any) => {
              const content = getLocalizedContent(res?.attributes?.localizedMetadata);
              const filteredData = searchResult.filter((item: any) =>
                item?.attributes?.tags?.includes(res?.attributes?.localizedMetadata[0]?.name)
              );

              return (
                <div key={res.id}>
                  {filteredData.length ? (<>
                    <h2 className="text-3xl font-barlowLight mt-6">{content?.name}</h2>
                    <CarouselSection
                      type={constants.VIDEOS}
                      data={filteredData}
                      addBookMark={addBookMark}
                      deleteBookMark={deleteBookMark}
                      seeAll={true}
                      filterTag={res?.attributes?.localizedMetadata[0]?.name}
                      from={APPROUTES.library}
                      catId={id}
                    />
                  </>) : null}
                </div>
              );
            })}

            <OtherSection
              searchResult={searchResult}
              addBookMark={addBookMark}
              deleteBookMark={deleteBookMark}
              type={constants.VIDEOS}
              data={data}
              keyword={keyword}
            />
          </>
        )}
      </div>
    </div>
  );
}

export default Videos;
